'use client';

import React from 'react';
import { css, cx } from 'styled-system/css';

import { useProfileStore } from '@shaojiang/store/profile';
import { Status } from '@shaojiang/types/common';
import { Project } from '@shaojiang/types/profile';

interface Props {
  children: React.ReactNode;
  project: Project;
}

const holder = css({
  position: 'relative',
  cursor: 'pointer',
  overflow: 'hidden',
  borderRadius: 'l2',
  transition: 'all 0.2s ease',
  _hover: { transform: 'translateY(-4px)', boxShadow: 'xl' },
});

/** Opens the project details dialog when its card is clicked. */
export function CardHolder({ children, project }: Props) {
  const setCurrentProject = useProfileStore((state) => state.setCurrentProject);

  return (
    <div
      role='button'
      tabIndex={0}
      onClick={() => setCurrentProject(project)}
      onKeyDown={(e) => e.key === 'Enter' && setCurrentProject(project)}
      className={cx(holder, project.status === Status.Inactive && css({ filter: 'grayscale(1)' }))}
    >
      {children}
    </div>
  );
}
